<div class="container mt-2">
  <div class="row h4">{{data.sheetTitle}}</div>
  <div *ngIf="!data.sheetHtml" class="row h6">{{data.sheetText}}</div>
  <div *ngIf="data.sheetHtml" class="row h6" [innerHTML]="data.sheetHtml"></div>
  <div class="row float-right mb-3">
    <button mat-raised-button class="btn btn-success" (click)="handleConfirm()">{{data.buttonText}}</button>
  </div>
</div>
